module.exports = __webpack_public_path__ + "img/limitation.aee04e6.png";